{
  "title": "Прогрес",
  "myTitle": "Мій прогрес",
  "description": "Відвідуваність, домашні завдання та результати — усе в одному місці.",
  "loadFailed": "Не вдалося завантажити сторінку прогресу.",
  "notAllowed": "У вас немає доступу до прогресу цього учня.",
  "noClasses": "Ще не зараховано до жодного класу.",
  "cards": {
    "attendance": "Відвідуваність",
    "attendanceMarked": "Позначено уроків: {{marked}}",
    "attendanceNone": "Ще нічого не позначено",
    "homework": "Домашні завдання",
    "homeworkSubmitted": "Здано {{submitted}} з {{assigned}}",
    "homeworkGraded": "Оцінено: {{graded}}",
    "onTime": "Вчасно: {{percent}}%",
    "onTimeNone": "Ще нічого не здано",
    "tests": "Тести",
    "testsTaken": "Пройдено: {{count}}",
    "testsAverage": "Середній результат {{percent}}%",
    "testsNone": "Результатів ще немає",
    "projects": "Проєкти",
    "projectsJoined": "У командах: {{count}}",
    "projectsGraded": "Оцінено: {{graded}}",
    "projectsNone": "Ще не в жодній команді проєкту",
    "points": "Бали",
    "pointsOf": "{{earned}} з {{possible}}",
    "pointsPercent": "{{percent}}% від оцінених робіт",
    "pointsNone": "Ще нічого не оцінено"
  },
  "attendanceBreakdown": "Присутні {{present}} · Запізнення {{late}} · З поважної причини {{excused}} · Відсутні {{absent}}",
  "timeline": {
    "title": "Оцінені роботи",
    "empty": "Поки що немає оцінених робіт.",
    "score": "{{score}} / {{max}}"
  },
  "kinds": {
    "test": "Тест",
    "homework": "Домашнє",
    "project": "Проєкт",
    "manual": "Стовпець"
  },
  "atRisk": {
    "title": "Потребують уваги",
    "description": "Учні класу, які перетнули один із порогів школи.",
    "empty": "Наразі нікого не позначено.",
    "loadFailed": "Не вдалося завантажити список.",
    "viewProgress": "Відкрити прогрес",
    "reasons": {
      "missing_homework": "Не здано {{value}} домашніх завдань після терміну (поріг — {{threshold}})",
      "low_attendance": "Відвідуваність {{value}}% — нижче за {{threshold}}%",
      "low_average": "Середній бал {{value}}% — нижче за {{threshold}}%"
    },
    "count_one": "{{count}} учень потребує уваги",
    "count_few": "{{count}} учні потребують уваги",
    "count_many": "{{count}} учнів потребують уваги",
    "count_other": "{{count}} учнів потребують уваги",
    "dashboardTitle": "Потребують уваги",
    "dashboardDescription": "Учні, які відстають у ваших класах.",
    "dashboardEmpty": "Наразі нікого не позначено.",
    "dashboardOpen": "Відкрити клас"
  }
}
